import type { RouteObject } from 'react-router';

import { horizonRouteToObject } from 'routing/utils/horizonRouteToObject';

import * as cmsRoute from './Cms.horizon-route';

export const cmsRouteObjects = [
  {
    path: '/*',
    ...horizonRouteToObject(cmsRoute),
  },
] satisfies RouteObject[];
